import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { AngleFrom, DragAngleCircleType } from '@tencent/wb-ext-form';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';

export interface IRotateFeature extends IBaseDrawerFeature {
    readonly rotate: number;
    handleRotateChange(value: number, from?: AngleFrom, dragState?: DragAngleCircleType);
}

export const IRotateFeature = Symbol.for('feature:drawer-rotate');

DynamicLoaderRegistry.merge(IRotateFeature, {
    useFactory: async () => {
        const { RotateFeature } = await import('./rotate-feature');
        return RotateFeature;
    },
    on: loadTask,
});
